module.exports = __webpack_public_path__ + "img/blank-comic-book_B098GV1GMZ.87a354fc.jpg";